import { FilterQueryType } from '@/app/types/types'
import { apiClient } from '..'

const getAvailableSlotsRequest = async (data: FilterQueryType) => {
    return apiClient().post('/api/calendar/availability', data)
}

export { getAvailableSlotsRequest }
